/* eslint-disable max-len */
import React, { useEffect, useState, Suspense, lazy, useContext } from 'react';
import CardHeader from '../../../../components/CardHeader';
import TopBarWithShadow from '../../../../components/TopBar/TopBarWithShadow';
import CustomOverLay from '../../../../components/CustomOverlay';
import { GetBranchId } from '../../../../CommonMethods/GetBranchId';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { dataService } from '../../../../services/data.services';
import { formatAdjustedDate, formatDateTime } from '../../../../CommonMethods/formatDate';
import GlobalContext from '../../../../components/Context/GloablContext';


const ItemsTable = lazy(() => import('./Components/ItemsTable'));

const ViewGRNDetails = () => {
    let {id} = useParams();
    const [loading, setLoading] = useState(false)
    const [viewGRNDetails, setViewGRNDetails] = useState({})
    const [searchParams, setSearchParams] = useSearchParams('')
    const {setToastErrorMessage} = useContext(GlobalContext)
    const navigate = useNavigate('')

    const getViewGRNDetails = async () =>{
        try{
            let grnID = encodeURIComponent(id)
            setLoading(true)
            const branch_id = await GetBranchId()
            let endpoint = `grn-entry/details?_id=${grnID}`
            const response = await dataService.GetAPI(endpoint)
            const temp = response?.data?.data
            setViewGRNDetails(temp)
        } catch(error) {
            navigate('/404')
            console.log(error)
            setLoading(false)
        } finally{
            setLoading(false)
        }
    } 

    useEffect(()=>{
        getViewGRNDetails()
    }, [])

    return(
        <CardHeader noPadding >
            <TopBarWithShadow
                Tittle={'GRN Details'} isback={true} backLocation={`/inventory-master/grn-entry?${searchParams.toString()}`}
            />
            {/* main body */}
            <Suspense fallback={<CustomOverLay Active text="Loading..." classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay`} />}>
                {loading ? <CustomOverLay Active text="Loading..." classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay`}/> 
                    : <div className='mainDataCntnrPageDiv scrollBlue_thick'>
                        {/* po details */}
                        <div className='flex justify-center items-center'>
                            <div className='flex w-[70%] border rounded'>
                                <div className='w-[50%] m-[20px]'>
                                    <div className='flex mb-4'>
                                        <a className='min-w-[115px]' id='po_number_label'>PO #</a>
                                        <a className='font-semibold break-all w-[200px]' id='po_number'>{viewGRNDetails?.po_number|| '-'}</a>
                                    </div>
                                    <div className='flex mb-4'>
                                        <a className='min-w-[115px]' id='grn_amount_label'>GRN Amount</a>
                                        <a className='font-semibold break-all w-[200px]' id='grn_amount'>{Number(viewGRNDetails?.grn_amount)?.toFixed(2) || '-'}</a>
                                    </div>
                                    <div className='flex mb-4'>
                                        <a className='min-w-[115px]' id='grn_date_label'>GRN Date</a>
                                        <a className='font-semibold break-all w-[200px]' id='grn_date'>{formatAdjustedDate(viewGRNDetails?.grn_date) || '-'}</a>
                                    </div>
                                    <div className='flex mb-4'>
                                        <a className='min-w-[115px]' id='grn_date_label'>Added Date</a>
                                        <a className='font-semibold break-all w-[200px]' id='grn_date'>{formatDateTime(viewGRNDetails?.created_at) || '-'}</a>
                                    </div>
                                    <div className='flex'>
                                        <a className='min-w-[115px]' id='fy_label'>FY</a>
                                        <a className='font-semibold break-all w-[200px]' id='fy'>{viewGRNDetails?.financial_year || '-'}</a>
                                    </div>
                                </div>
                                <div className='w-[50%] m-[20px]'>
                                    <div className='flex mb-4'>
                                        <a className='w-[140px]' id='grn_number_label'>GRN #</a>
                                        <a className='font-semibold break-all ' id='grn_number'>{viewGRNDetails?.grn_number || '-'}</a>
                                    </div>
                                    <div className='flex mb-4'>
                                        <a className='w-[140px]' id='vendor_name_label'>Vendor Name</a>
                                        <a className='font-semibold break-all ' id='vendor_name'>{viewGRNDetails?.vendor_name || '-'}</a>
                                    </div>
                                    <div className='flex mb-4'>
                                        <a className='w-[140px]' id='vendor_invoice_label'>Vendor Invoice #</a>
                                        <a className='font-semibold break-all ' id='vendor_invoice'>{viewGRNDetails?.vendor_invoice || '-'}</a>
                                    </div>
                                    <div className='flex mb-4'>
                                        <a className='w-[140px]' id='vendor_invoice_label'>Pending Amount</a>
                                        <a className='font-semibold break-all ' id='vendor_invoice'>{viewGRNDetails?.pending_amount || '0.00'}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* items list */}
                        {viewGRNDetails?.items !== undefined && viewGRNDetails?.items.length !== 0 && <div className='mt-[30px] w-[95%] mx-auto'>
                            <a className=' font-semibold text-xl ml-[7px]'>Items</a>
                            <ItemsTable ItemsList={viewGRNDetails?.items}/>
                        </div>}
                    </div>}
            </Suspense>
        </CardHeader>
    )
}

export default ViewGRNDetails;